import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SettlementModalPage } from './settlement-modal';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
	declarations: [
		SettlementModalPage,
	],
	imports: [
		ComponentsModule,
		IonicPageModule.forChild(SettlementModalPage),
	],
})
export class SettlementModalPageModule {}



// WEBPACK FOOTER //
// ./src/pages/settlement-modal/settlement-modal.module.ts